import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';

export const resultSchema = new schema.Entity(EntityTypes.Result);
